import React, { useState, useEffect, useCallback } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar, gridClasses } from "@mui/x-data-grid";
import "../../static/css/App.css";
import "../../static/css/customerTable.css";
import Loader from "../loader/loader";
import DynamicBreadcrumb from "../header/breadcrumb";
import menuApi from "../../services/menuapi"; 

const MenuList = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowSelectionModel, setRowSelectionModel] = useState([]);
    const [sortModel, setSortModel] = useState([]);
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 15,
    });
    const [totalRecords, setTotalRecords] = useState(0);
    const [loaderVisible, setLoaderVisible] = useState(false);

    const fetchMenus = useCallback(async () => {
        setLoaderVisible(true);
        setLoading(true);
        try {
            const { page, pageSize } = paginationModel;

            const payload = {
                page,
                limit: pageSize,
                sortModel,
                filterModel,
            };

            const response = await menuApi.getMenus(payload);
            // console.log(response.data.result,'response');
            const data = response.data;

            const formattedRows = data.result.map((menu, index) => ({
                id: menu.id,
                sno: index + 1 + page * pageSize,
                title: menu.title,
                slug: menu.slug,
                icon: menu.icon,
                uri: menu.uri,
                parentId: menu.parentMenu ? menu.parentMenu.title : 'Root',
                status: menu.status === 1 ? "Active" : "Inactive",
                createdAt: menu.createdAt?.split("T")[0] || "",
            }));

            setRows(formattedRows);
            setTotalRecords(data.totalRecords || 0);
        } catch (err) {
            console.error("Failed to load menu list:", err);
        } finally {
            setLoading(false);
            setLoaderVisible(false);
        }
    }, [paginationModel, sortModel, filterModel]);

    useEffect(() => {
        fetchMenus();
    }, [fetchMenus]);



    const columns = [
        { field: "sno", headerName: "S No", width: 80 },
        { field: "title", headerName: "Title", flex: 1 },
        { field: "slug", headerName: "Slug", flex: 1 },
        { field: "uri", headerName: "URI", flex: 1,sortable: false },
        { field: "icon", headerName: "Icon", flex: 1,sortable: false},
        { field: "parentId", headerName: "Parent ID", flex: 1 },
        { field: "status", headerName: "Status", flex: 1 },
        { field: "createdAt", headerName: "Created At", flex: 1 },
    ];

    const pathArray = [{ name: "Menu List", url: null }];

    return (
        <Container className="mt-4 mb-4">
            <DynamicBreadcrumb pathArray={pathArray} />
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Menus</h5>
            </div>
            {loaderVisible && <Loader />}

            {/* Data Table */}
            <Box>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowHeight={() => "auto"}
                    paginationMode="server"
                    sortingMode="server"
                    filterMode="server"
                    rowCount={totalRecords}
                    pageSizeOptions={[5, 10, 15, 20]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    onSortModelChange={setSortModel}
                    onFilterModelChange={setFilterModel}
                    loading={loading}
                    checkboxSelection
                    onRowSelectionModelChange={(row) => setRowSelectionModel(row)}
                    rowSelectionModel={rowSelectionModel}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            csvOptions: { disableToolbarButton: true },
                            printOptions: { disableToolbarButton: true },
                        },
                    }}
                    sx={{
                        [`& .${gridClasses.cell}`]: { py: 1 },
                    }}
                />
            </Box>
        </Container>
    );
};

export default MenuList;
